import * as S from '@/components/common/Tab/TabList/style';
import useIsMobile from '@/hooks/useIsMobile';
import ArrowDownIcon from '../../../Icon/ArrowDownIcon';
import { useRef, useState } from 'react';
import useClickOutside from '@/hooks/useClickOutSide';
import uuid from 'react-uuid';

interface TabListProps {
	menuList: string[];
	menuKey: string;
	isNotSticky?: boolean;
	onListClick: (menu: string) => void;
}

const TabList = ({ menuList, menuKey, onListClick, isNotSticky = false }: TabListProps) => {
	const isMobile = useIsMobile(900);
	const [open, setOpen] = useState(false);
	const dropdownRef = useRef(null);

	const handleSelect = (option: string) => {
		setOpen(false);
		onListClick(option);
	};

	useClickOutside(dropdownRef, () => setOpen(false));

	return (
		<>
			{!isMobile && (
				<S.TabListContainer isNotSticky={isNotSticky}>
					{menuList.map((menu, index) => (
						<S.TabListItem key={index} className={menuKey === menu ? 'active' : ''} onClick={() => onListClick(menu)}>
							{menu}
						</S.TabListItem>
					))}
				</S.TabListContainer>
			)}
			{isMobile && (
				<S.DropdownContainer isNotSticky={isNotSticky}>
					<S.DropdownWrapper isNotSticky={isNotSticky} ref={dropdownRef}>
						<S.DropdownButton onClick={() => setOpen(!open)}>
							{menuKey}

							<S.ArrowDown open={open}>
								<ArrowDownIcon />
							</S.ArrowDown>
						</S.DropdownButton>
						<S.DropdownList open={open}>
							{menuList.map((option) => (
								<S.DropdownItem key={uuid()} onClick={() => handleSelect(option)}>
									{option}
								</S.DropdownItem>
							))}
						</S.DropdownList>
					</S.DropdownWrapper>
				</S.DropdownContainer>
			)}
		</>
	);
};

export default TabList;
